<template>
<div>
  <v-tabs v-model="tab" fixed-tabs background-color="#BBA981" dark>
    <v-tabs-slider color="#668871"></v-tabs-slider>
    <v-tab v-for="item in ['Equipes', 'Jeu']" :key="item">
      {{ item }}
    </v-tab>
  </v-tabs>
  <v-tabs-items v-model="tab">
    <div style="height: calc(100% - 48px);" class="pa-5">
      <v-img class="background" src="/img/background-blur.jpg"></v-img>
      <v-tab-item>
          <v-row>
            <v-col cols="12" xs="12">
              <v-data-table style="position:relative;" :headers="headers" :items="teams" 
                  hide-default-footer dense show-expand :expanded.sync="expanded">
                <template v-slot:item.status="{ item }">
                  <div :class="[item.status ? 'status-green' : 'status-red']"></div>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <v-simple-table v-if="gameGuessStep(item.id).length > 0">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Sens</th>
                            <th class="text-left">1er essai</th>
                            <th class="text-left">2er essai</th>
                            <th class="text-left">3er essai</th>
                            <th class="text-left">Perdu</th>
                            <th class="text-left">Temps réalisé</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(step, index) in gameGuessStep(item.id)" :key="index">
                            <td>{{ guessStepType(step.stepIndex).toUpperCase() }}</td>
                            <td><v-icon v-if="step.nbTries === 0" color="green darken-2">mdi-check</v-icon></td>
                            <td><v-icon v-if="step.nbTries === 1" color="green darken-2">mdi-check</v-icon></td>
                            <td><v-icon v-if="step.nbTries === 2" color="green darken-2">mdi-check</v-icon></td>
                            <td><v-icon v-if="step.nbTries === 3" color="red darken-2">mdi-close</v-icon></td>
                            <td>{{ step.time }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </td>
                </template>
              </v-data-table>
            </v-col>
            <v-col v-if="waitingTeams" cols="12" xs="12">
              <loader></loader>
            </v-col>
            <v-col cols="12" xs="12">
              <v-btn id="start-btn" v-if="waitingTeams" @click="startGame">Lancer la partie !</v-btn>
              <v-btn id="start-btn" v-if="!waitingTeams" @click="goToNextStep">Etape Suivante</v-btn>
            </v-col>
          </v-row>
      </v-tab-item>
      <v-tab-item>
        <div v-if="gameStep" class="gameContent">
          <game-content :page="page" :gameStep="gameStep" @refresh="refresh">
            <template #timer>
              <flip-countdown v-if="deadline" :deadline="deadline" :showDays="false" :showHours="false"></flip-countdown>
            </template>
          </game-content>
        </div>
      </v-tab-item>
      </div> 
  </v-tabs-items>
</div>

</template>

<script>
  import Loader from '../components/Loader.vue'
  import {P2P} from '../plugins/p2p.js'
  import GameContent from '../components/GameContent.vue'
  import FlipCountdown from 'vue2-flip-countdown'
  import moment from 'moment'

  /**
   * @brief External view managing master game progress (btob only).
   * @bug No known bugs.
   */
  export default {
    components: { Loader, GameContent, FlipCountdown},
    name: 'Master',
    data: () => ({
      waitingTeams: true,
      p2p: null,
      teams: [],
      tab: null,
      page: {},
      gameStep: {},
      expanded: [],
      headers: [
        {text: "Nom de l'équipe", value: 'name'},
        {text: "Status", value: 'status'},
        {text: "Score", value: 'score'}
      ]
    }),
    watch: {
      'p2p.members': {
        handler: function() {
          this.teams = this.refreshTeams()
        },
        deep: true
      }
    },
    computed: {
      deadline: function () {
        return this.maxTime && this.maxTime !== 0 ? moment().add(this.maxTime, 'second').format('YYYY-MM-DD HH:mm:ss') : undefined
      },
      gameGuessStep: function () {
        return (teamId) => {
          var teams = this.teams.filter((x) => x.id === teamId)
          return teams.lenght === 0 ? [] : teams[0].steps.filter((x) => x.gameType === 'guess')
        }
      },
      guessStepType: function () {
        return (stepIndex) => {
          var type = SAPIO.Scenario.instance.steps[stepIndex].selectedSenseType
          return type ? type : ''
        }
      },
    },
    created() {
      if (SAPIO.Scenario.instance === undefined) SAPIO.Scenario.LS_GET()
      if (SAPIO.Game.instance === undefined) SAPIO.Game.LS_GET()
      if (SAPIO.Team.instance === undefined) SAPIO.Team.LS_GET()
    },
    mounted() {
      setInterval(() => {
        var step = SAPIO.Scenario.instance.steps[SAPIO.Game.instance.currentStepIndex]
        this.maxTime = step && step.maxTime ? step.maxTime : 0
      }, 500)
      if (!SAPIO.Loader.instance.isReady()) this.$router.push({ path: '/login' })
      this.waitingTeams = SAPIO.Game.instance.currentStepIndex === undefined;
      this.p2p = new P2P('sapio-game-' + SAPIO.Game.instance.id, 'Master')
      this.p2p.openConnection()
      this.p2p.registerEvents('master', [
        {eventName:"update-team-state", callback: (message, client) => this.updateTeamState(message, client)},
        {eventName:"get-team-state", callback: (message, client) => this.getTeamState(message, client)}
      ])
      this.teams = this.refreshTeams()
      if (SAPIO.Game.instance.currentStepIndex >= 0) this.refresh();
    },
    methods: {
      startGame() {
        this.waitingTeams = false;
        this.p2p.sendMessage({to: "client", from: "master", eventName: "start-game"})
        this.teams = this.refreshTeams()
        SAPIO.Game.instance.goToNextStep()
        SAPIO.Game.instance.LS_SAVE()
        this.refresh();
      },
      goToNextStep() {
          if (SAPIO.Game.instance.currentStepIndex >= SAPIO.Scenario.instance.steps.length - 1) this.$router.push('/ranking')
          else SAPIO.Game.instance.goToNextStep()
          SAPIO.Game.instance.LS_SAVE()
          this.p2p.sendMessage({to: "client", from: "master", eventName: "go-to-step", data: {stepIndex: SAPIO.Game.instance.currentStepIndex}})
          this.teams = this.refreshTeams()
          this.refresh();
      },
      refreshTeams() {
        var teams = []
        if (this.p2p) this.p2p.members.forEach((el) => {
          if (el.clientData.teamId) 
            teams.push({
              id: el.clientData.teamId, 
              name: el.clientData.teamName, 
              status: SAPIO.Game.instance.teamsHaveResponsed ? SAPIO.Game.instance.teamsHaveResponsed.get(el.clientData.teamId) : true, 
              score: SAPIO.Game.instance.teamsScore.get(el.clientData.teamId),
              steps: SAPIO.Game.instance.teamStates.get(el.clientData.teamId)
            })
        })
        teams = teams.sort((a,b) => a.score - b.score)
        return teams;
      },
      refresh(type = '') { 
        this.gameStep = SAPIO.Game.instance.gameStep;
        if (type === 'info') this.gameStep.showExtraInfo();
        if (type === 'aop') this.gameStep.step.maxTime = 0;
        this.gameStep = SAPIO.Game.instance.gameStep;
        this.page = SAPIO.Game.instance.page;
      },
      updateTeamState(message, client) {
        const value = SAPIO.Game.gameStepsAttributeTransformToClass(message.data.teamStates)
        SAPIO.Game.instance.teamStates.set(client.clientData.teamId, value.get(client.clientData.teamId))
        this.teams = this.refreshTeams()
        SAPIO.Game.instance.LS_SAVE()
      },
      getTeamState(message, client) {
        var data = JSON.parse(JSON.stringify(SAPIO.Game.instance.getJSON()))
        if (client.clientData.teamId && SAPIO.Game.instance.currentStepIndex !== undefined) {
          data.teamId = client.clientData.teamId
          var tmp = data.teamStates[client.clientData.teamId]
          if (tmp === undefined) data.teamStates = {[client.clientData.teamId]: data.teamStates["-1"]}
          else data.teamStates = {[client.clientData.teamId]: tmp}
          data.user_id = client.clientData.userId
          this.p2p.sendMessage({to: "client", from: "master", eventName: "response-get-team-state", data})
        }
      }
    }
  }
</script>

<style scoped>
  #start-btn {
    left: 50%;
    transform: translateX(-50%);
  }
  .background {
    position: fixed;
    top: 112px;
    left: 0;
    min-width: 100%;
    min-height: 100%;
  }

  .status-green {
    height: 20px;
    width: 20px;
    background-color: green;
    border-radius: 50%;
  }

  .status-red {
    height: 20px;
    width: 20px;
    background-color: red;
    border-radius: 50%;
  }

  .gameContent {
    position: relative;
    height: calc(100vh - 152px);
    font-size: calc(14px + (26 - 14) * ((100vw - 300px) / (1600 - 300)));
  }

  .gameContent >>> .flip-card__top, .gameContent >>> .flip-card__bottom, .gameContent >>> .flip-card__bottom::after, 
  .gameContent >>> .flip-card__back, .gameContent >>> .flip-card__back::before, 
  .gameContent >>> .flip-card__back-bottom, .gameContent >>> .flip-card__back-bottom::after {
    color: #FFF;
  }
</style>
